var _ConsoleLogExporter_minimumLogLevel, _ConsoleLogExporter_isShutdown;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import { SeverityNumber } from '@opentelemetry/api-logs';
import { ExportResultCode } from '@opentelemetry/core';
const explicitLogMethods = {
    [SeverityNumber.TRACE]: console.debug,
    [SeverityNumber.DEBUG]: console.debug,
    [SeverityNumber.INFO]: console.info,
    [SeverityNumber.WARN]: console.warn,
    [SeverityNumber.ERROR]: console.error,
    [SeverityNumber.FATAL]: console.error,
};
const parseLogRecord = (record) => {
    let logRecordString = `[${record.severityText ||
        record.severityNumber ||
        'SEV-UNKOWN'}@${record.instrumentationScope.name}] `;
    logRecordString += `@${new Date(record.hrTime[0] * 1000).toISOString()}: `;
    if (record.spanContext) {
        logRecordString += `{trace: ${record.spanContext.traceId}, span: ${record.spanContext.spanId}, flags: ${record.spanContext.traceFlags}} `;
    }
    if (record.attributes) {
        logRecordString += `(Attributes:{${JSON.stringify(record.attributes)}}) `;
    }
    if (record.body) {
        logRecordString += `${JSON.stringify(record.body)}`;
    }
    return logRecordString;
};
export class ConsoleLogExporter {
    constructor(minimumLogLevel = SeverityNumber.UNSPECIFIED) {
        _ConsoleLogExporter_minimumLogLevel.set(this, void 0);
        _ConsoleLogExporter_isShutdown.set(this, void 0);
        __classPrivateFieldSet(this, _ConsoleLogExporter_minimumLogLevel, minimumLogLevel, "f");
        __classPrivateFieldSet(this, _ConsoleLogExporter_isShutdown, false, "f");
        if (typeof console === 'undefined') {
            throw new Error('Console Not Found. Does this environment support console?');
        }
    }
    async export(logRecords, resultCallback) {
        if (__classPrivateFieldGet(this, _ConsoleLogExporter_isShutdown, "f")) {
            resultCallback({
                code: ExportResultCode.FAILED,
                error: new Error('ConsoleLogExporter is shutdown. No more logs will be exported.'),
            });
            return;
        }
        logRecords
            .filter(record => (record.severityNumber || 0) >= __classPrivateFieldGet(this, _ConsoleLogExporter_minimumLogLevel, "f"))
            .forEach(record => {
            const consoleMethod = explicitLogMethods[record.severityNumber || SeverityNumber.UNSPECIFIED] || console.log;
            consoleMethod(parseLogRecord(record));
        });
        resultCallback({
            code: ExportResultCode.SUCCESS,
        });
    }
    async shutdown() {
        __classPrivateFieldSet(this, _ConsoleLogExporter_isShutdown, true, "f");
    }
    async forceFlush() { }
}
_ConsoleLogExporter_minimumLogLevel = new WeakMap(), _ConsoleLogExporter_isShutdown = new WeakMap();
//# sourceMappingURL=console-exporter.js.map